"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkTaskTime = exports.isTaskTime = void 0;
const Check_1 = require("../check/Check");
function isTaskTime(object) {
    return checkTaskTime(object).fulfilled;
}
exports.isTaskTime = isTaskTime;
function checkTaskTime(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, Check_1.check)(object, (0, Check_1.hasString)("id"), (0, Check_1.hasString)("taskId"), (0, Check_1.hasNumber)("startTime").integer(), (0, Check_1.hasNumber)("endTime").integer(), (0, Check_1.hasString)("userId").optional(), (0, Check_1.hasString)("userName").optional(), (0, Check_1.hasString)("companyId").nonEmpty().optional()).withOptions(options).explain();
}
exports.checkTaskTime = checkTaskTime;
//# sourceMappingURL=TaskTime.js.map